import ApiServiceV6Core from '@/helpers/api.service.v6core';
const APIV6Core = new ApiServiceV6Core();


export const state = {
   networksList: [],
   providersList: [],
   categoriesList: [],
   servicesList: [],
   unlistedSKUList: [],
   listedSKUList: []
}

export const mutations = {
    UPDATE_NETWORKS_LIST(state, value) {
        state.networksList = value;
    },
    UPDATE_PROVIDERS_LIST(state, value) {
        state.providersList = value;
    },
    UPDATE_CATEGORIES_LIST(state, value) {
        state.categoriesList = value;
    },
    UPDATE_SERVICES_LIST(state, value) {
        state.servicesList = value;
    },
    UPDATE_UNLISTED_SKU_LIST(state, value) {
        state.unlistedSKUList = value;
    },
    UPDATE_LISTED_SKU_LIST(state, value) {
        state.listedSKUList = value;
    },
}

export const actions = {
    fetchCoreNetworksList({commit}, params) {
        return new Promise((resolve, reject) => {
            APIV6Core.get(`/eload/dropdown/networks`, params)
            .then((response) => {
                commit('UPDATE_NETWORKS_LIST', response.data.message.rows);
                resolve(response.data);
            }
            )
            .catch((error) => {
                reject(error);
            });
        });
    },
    fetchCoreProvidersList({commit}, params) {
        return new Promise((resolve, reject) => {
            APIV6Core.get(`/eload/dropdown/providers`, params)
            .then((response) => {
                commit('UPDATE_PROVIDERS_LIST', response.data.message.rows);
                resolve(response.data);
            }
            )
            .catch((error) => {
                reject(error);
            });
        });
    },
    fetchCoreCategoriesList({commit}, params) {
        return new Promise((resolve, reject) => {
            APIV6Core.get(`/eload/dropdown/categories`, params)
            .then((response) => {
                commit('UPDATE_CATEGORIES_LIST', response.data.message.rows);
                resolve(response.data);
            }
            )
            .catch((error) => {
                reject(error);
            });
        });
    },
    fetchCoreServicesList({commit}, params) {
        return new Promise((resolve, reject) => {
            APIV6Core.get(`/eload/dropdown/services`, params)
            .then((response) => {
                commit('UPDATE_SERVICES_LIST', response.data.message.rows);
                resolve(response.data);
            }
            )
            .catch((error) => {
                reject(error);
            });
        });
    },
    fetchCoreUnlistedSKUList({commit}, params) {
        return new Promise((resolve, reject) => {
            APIV6Core.get(`/eload/dropdown/digicore_unlisted_skus`, params)
            .then((response) => {
                commit('UPDATE_UNLISTED_SKU_LIST', response.data.message.rows);
                resolve(response.data);
            }
            )
            .catch((error) => {
                reject(error);
            });
        });
    },
    fetchCoreListedSKUList({commit}, params) {
        return new Promise((resolve, reject) => {
            APIV6Core.get(`/eload/dropdown/digicore_listed_skus`, params)
            .then((response) => {
                commit('UPDATE_LISTED_SKU_LIST', response.data.message.rows);
                resolve(response.data);
            }
            )
            .catch((error) => {
                reject(error);
            });
        });
    }
}

export const getters = {
   
}